//
// Copyright (c) 2008-2025 Barry E. Mapen All Rights Reserved
//
export const waiver = 
<div className="waiver">
    <h2>ADDENDUM TO MEMBERSHIP AGREEMENT</h2>
    <p>
        <b>IMPORTANT! PLEASE READ CAREFULLY. THIS IS A CONTRACT. BY CLICKING THE BUTTON BELOW THAT STATES
            &quot;ACCEPT&quot;, YOU ACCEPT ALL TERMS OF THIS MEMBERSHIP AGREEMENT
            ADDENDUM, AND THIS MEMBERSHIP AGREEMENT ADDENDUM WILL BE A VALID AND LEGALLY BINDING DOCUMENT BETWEEN YOU AND
            US.
        </b>
    </p>
    <p>
        I/We acknowledge the contagious and serious nature of the Coronavirus/COVID-19.
    </p>
    <p>
        I/We further acknowledge and agree that Red Door Operations, LLC d/b/a Choice Social Club (the &quot;Club&quot;) has
        implemented preventative measures recommended by state and local public health authorities to reduce the spread of
        the Coronavirus/COVID-19 at its facility.
    </p>
    <p>
        I/We further acknowledge and agree that, due to the nature of Club events, the Club <b><u>cannot guarantee</u></b> that
        I/we will not become infected with Coronavirus/COVID-19 on account of my/our attendance at Club events. I/We
        understand and agree that the risk of becoming exposed to and/or infected by the Coronavirus/COVID-19 while
        attending Club
        events may result from the actions, omissions, or negligence of myself/ourselves and others including, but not
        limited to,
        the Club&lsquo;s owners, staff, and members.
    </p>
    <p>
        I hereby represent and attest that:
    </p>
    <ul>
        <li>
            I/We have been fully vaccinated (<a
                href="https://www.cdc.gov/vaccines/covid-19/clinical-considerations/covid-19-vaccines-us.html#Administration">as
                defined by the CDC</a>) with a CDC approved COVID-19 vaccine and will provide proof of such by producing
            my/our actual CDC Vaccination card as part of the event check-in process.
        </li>
        <li>
            I/We am not experiencing any symptom of illness such as cough, shortness of breath or difficulty breathing,
            fever,
            chills, repeated shaking with chills, muscle pain, headache, sore throat, or new loss of taste or smell.
        </li>
        <li>
            I/We have not traveled internationally within the last 14 days.
        </li>
        <li>
            I/We have not traveled to an area highly impacted by Coronavirus/COVID-19 within the United States of America in
            the
            last 14 days.
        </li>
        <li>
            I/We do not believe I/we have been exposed to someone with a suspected and/or confirmed case of the
            Coronavirus/COVID-19.
        </li>
        <li>
            I/We have not been diagnosed with Coronavirus/Covid-19 and not yet been cleared as non-contagious by state or
            local
            public health authorities.
        </li>
        <li>
            I/We am following all CDC recommended guidelines as much as possible and limiting my/our exposure to the
            Coronavirus/COVID-19.
        </li>
    </ul>
    <p>
        In consideration of my/our attendance at Club events, to the maximum extent permitted by law, I/we hereby release
        and
        agree to hold the Club and its owners and staff harmless from, and waive on behalf of myself/ourselves, my/our
        heirs,
        and any personal representatives of mine/ours, any and all causes of action, claims, demands, damages, costs,
        expenses,
        liabilities and compensation for damage, injury, illness, or loss to myself/ourselves that may be directly or
        indirectly
        caused by any act or failure to act on the part of the Club or any of the Club&lsquo;s owners, staff, or members, or that
        may
        otherwise arise in any way in connection with my/our attending any event at the Club. I/we understand that this
        release
        and waiver discharges the Club from any and all liabilities or claims that I/we, my/our heirs, or any personal
        representatives of mine/ours may have against the Club with respect to or in any way whatsoever related to any
        bodily
        injury, illness, death, and/or medical treatment that may arise from, or in connection with, my/our attending any
        event
        at the Club. I/we also acknowledge and agree that I/we have been provided the opportunity to decline entering the
        Club
        and have affirmatively decided to attend a Club event after the Club has communicated adequate information with
        respect
        to Coronavirus/COVID-19. This liability waiver and release extends to the Club&lsquo;s ownership, partners, members, staff
        and
        employees and forms a part of my/our previously executed Membership Agreement with the Club.
    </p>

    <p>
        <b>
            YOU ACKNOWLEDGE THAT YOU HAVE READ THE FOREGOING MEMBERSHIP AGREEMENT ADDENDUM AND UNDERSTAND IT.
            BY CLICKING THE &quot;ACCEPT&quot; BUTTON BELOW, YOU CERTIFY THAT
            YOU HAVE READ THIS AGREEMENT ADDENDUM, AND YOU CONSENT TO BE BOUND BY ITS TERMS AND CONDITIONS. BY
            CLICKING THE &quot;DECLINE&quot; BUTTON BELOW, YOU ARE REJECTING
            THIS AGREEMENT AND YOUR ATTENDANCE PRIVILEGES.
        </b>
    </p>
</div>